var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
var LoadingIndicator = function (_a) {
    var message = _a.message;
    return (_jsxs(Grid, __assign({ container: true, direction: "column", alignItems: "center", style: { marginTop: "10%" } }, { children: [_jsx(CircularProgress, { color: "primary" }, void 0), _jsx(Typography, __assign({ component: "span", color: "secondary", style: { marginTop: "8px" } }, { children: message !== null && message !== void 0 ? message : "Initializing..." }), void 0)] }), void 0));
};
export default LoadingIndicator;
